import CategoryColor from './CategoryColor';

export const DEFAULT_CATEGORY_COLOR_CODE = CategoryColor.GreyDark;
